import Swiper from "swiper/bundle";
export default class AroundSwiper {
  constructor() {
    const around = document.getElementById("around");
    window.aroundSwiper = new Swiper(".swiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // mousewheel: true,
      slideToClickedSlide: true,
      slidesPerView: "auto",
      spaceBetween: 24,
      clickable: true,
      loop: true,
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        769: {
          loop: false,
          //allowTouchMove: false,
        },
      },
    });
    const mapTarget = map.querySelectorAll(`[id^='mapTarget']`);
    for (let i = 0; i < mapTarget.length; i++) {
      if (around.className.indexOf(mapTarget[i].className) !== -1) {
        // console.log(mapTarget[i].className);
        aroundSwiper.slideTo(i, 0, function () {});
        afterChange();
      }
    }

    if (window.matchMedia("(min-width:769px)").matches) {
      aroundSwiper.on("slideChange", function (e) {
        const currentName = mapTarget[aroundSwiper.realIndex].classList[0];
        around.className = "around" + " " + currentName;
        afterChange();
      });
      aroundSwiper.on("beforeSlideChangeStart", function (e) {
        // console.log(aroundSwiper.realIndex + " beforeSlideChangeStart");
        if (aroundSwiper.realIndex === 7) {
          document
            .querySelector("#around .around__right #swiperWrap")
            .classList.add("fixed-poz");
        }
      });
    }

    function afterChange() {
      if (aroundSwiper.realIndex <= 7) {
        document
          .querySelector("#around .around__right #swiperWrap")
          .classList.remove("fixed-poz");
      }
      //   if (aroundSwiper.realIndex > 7) {
      //     document
      //       .querySelector("#around .around__right #swiperWrap")
      //       .classList.add("fixed-poz");
      //   }
      if (aroundSwiper.realIndex > 0) {
        document
          .querySelector("#around .around__right #swiperWrap")
          .classList.add("adjust-poz");
      } else {
        document
          .querySelector("#around .around__right #swiperWrap")
          .classList.remove("adjust-poz");
      }
      if (window.matchMedia("(min-width: 769px)").matches) {
        if (9 > aroundSwiper.realIndex > 0) {
          const buttonPrev = document.getElementById("buttonPrev");
          const buttonNext = document.getElementById("buttonNext");
          buttonPrev.style.display = "none";
          buttonNext.style.display = "none";
        }
        if (aroundSwiper.realIndex === 0) {
          buttonPrev.style.display = "block";
          buttonNext.style.display = "none";
          buttonPrev.addEventListener("click", () => {
            aroundSwiper.slideTo(9, 1000, function () {});
          });
        }
        if (aroundSwiper.realIndex === 9) {
          buttonPrev.style.display = "none";
          buttonNext.style.display = "block";
          buttonNext.addEventListener("click", () => {
            aroundSwiper.slideTo(0, 1000, function () {});
          });
        }
      }
    }
    window.addEventListener("resize", afterChange);
    afterChange();
  }
}
